export const match = {
  confirm: {
    title: "Match Result",
    confirmed: "Confirmed",
    disputed: "Disputed",
    pending: "Pending",
    confirmAction: "Confirm Score",
    disputeAction: "Dispute",
    disputeReason: "Reason (optional)",
    evidenceRequired: "Court photo required for ranked matches",
    takePhoto: "Take Court Photo",
    verified: "Match Verified",
    statusBadge: {
      confirmed: "✓",
      disputed: "✗",
      pending: "⏳",
    },
  },
  evidence: {
    privacy: "Photos are automatically deleted 2 days after match verification",
  },
};
